import './advertising'
import ga4 from '@/components/modules/ga4'
import sweetAlert from '@/components/modules/sweetAlert'
import { mapGetters } from 'vuex'
const Cart = {
  mixins: [ga4, sweetAlert],
  computed: {
    ...mapGetters([
      'authorized',
      'cartList'
    ])
  },
  methods: {
    getItemUrl (type) {
      const urls = {
        BOOK: '/book/detail/',
        PACKAGE: '/package/detail/',
        ITEM: '/package/detail/',
        MAGAZINE: '/magazine/detail/',
        SUBSCRIPTION: '/magazine/detail/'
      }
      return urls[type] || ''
    },

    async popupAddCart () {
      const { state, dispatch } = this.$store
      await dispatch('isAddingCart', !state.isAddCart)
      dispatch('isAddingCart', true)
    },

    // 加入購物車
    async addShoppingList (item, gifts) {
      if ((item.begin_at && item.end_at) || item.type !== 'SUBSCRIPTION') {
        this.modifyShoppingCart(item, {
          gifts,
          showPopup: true,
          enableTracking: true
        })
      }
    },

    async addMultipleToCart (items) {
      if (items.length < 1) return
      const products = JSON.parse(JSON.stringify(this.cartList)) || []
      let modified = false

      for (const item of items) {
        if (!item) continue

        const isSubscription = item.type === 'SUBSCRIPTION'
        const isValidSubscription = isSubscription && item.begin_at && item.end_at
        if (!isValidSubscription && isSubscription) continue

        const newItem = {
          ...item,
          quantity: 1,
          selected_gifts: item.selected_gifts || null,
          link: this.getItemUrl(item.type) + (isSubscription && item.link_id ? item.link_id : item.id)
        }

        const digitalCount = products
          .filter(p => p.is_digital)
          .reduce((sum, p) => sum + p.quantity, 0)

        if (item.is_digital && digitalCount >= 20) {
          this.alertPop('warning', '已達電腦互動學習軟體購買上限（20筆）')
          continue
        }

        const existingItem = products.find(p => p.id === item.id)

        if (existingItem) {
          if (isSubscription) {
            const sameGift = existingItem.selected_gifts === item.selected_gifts
            const sameCreated = existingItem.created_at === item.created_at
            const sameEnded = existingItem.end_at === item.end_at
            const isRegisteredMail = existingItem.isRegisteredMail === item.isRegisteredMail

            if (sameGift && sameCreated && sameEnded && isRegisteredMail) {
              existingItem.quantity += 1
            } else {
              products.push(newItem)
            }
          } else if (existingItem.quantity < item.in_stock) {
            existingItem.quantity += 1
          }
        } else {
          products.push(newItem)
        }

        modified = true
        this.add_to_cart(item)
      }

      if (modified) {
        if (this.authorized) {
          await this.$store.dispatch('postCart', this.cleanItems(products))
        } else {
          localStorage.setItem('products', JSON.stringify(products))
        }

        await this.$store.dispatch('updateCart')

        // 最後一次顯示 popup
        this.popupAddCart()

        // GA 追蹤最後一筆商品
        const lastItem = items[items.length - 1]?.item
        if (lastItem) {
          this.addCartCode({
            productID: lastItem.id,
            unit: '1',
            price: lastItem.pricing
          })
        }
      }
    },
    // 更新購物車
    async updatedShoppingList (item) {
      this.modifyShoppingCart(item, {
        showPopup: false,
        enableTracking: false
      })
    },

    async modifyShoppingCart (item, {
      gifts = null,
      showPopup = false,
      enableTracking = false
    } = {}) {
      // GA4 加入追蹤
      if (enableTracking) this.add_to_cart(item)

      let products = JSON.parse(JSON.stringify(this.cartList)) || []

      const newItem = {
        ...item,
        quantity: 1,
        selected_gifts: gifts || item.selected_gifts || null,
        link: this.getItemUrl(item.type) + (item.type === 'SUBSCRIPTION' && item.link_id ? item.link_id : item.id)
      }

      const digitalCount = products
        .filter(p => p.is_digital)
        .reduce((sum, p) => sum + p.quantity, 0)

      if (item.is_digital && digitalCount >= 20) {
        return this.alertPop('warning', '已達電腦互動學習軟體購買上限（20筆）')
      }

      const existingItem = products.find(p => p.id === item.id)
      let shouldSave = false

      if (existingItem) {
        if (item.type === 'SUBSCRIPTION') {
          const sameGift = existingItem.selected_gifts === item.selected_gifts
          const sameCreated = existingItem.created_at === item.created_at
          const sameEnded = existingItem.end_at === item.end_at
          const isRegisteredMail = existingItem.isRegisteredMail === item.isRegisteredMail

          if (sameGift && sameCreated && sameEnded && isRegisteredMail) {
            existingItem.quantity += 1
          } else {
            products.push(newItem)
          }
          shouldSave = true
        } else if (existingItem.quantity < item.in_stock) {
          existingItem.quantity += 1
          shouldSave = true
        }
      } else {
        products.push(newItem)
        shouldSave = true
      }

      if (shouldSave) {
        const saveCart = async (val) => {
          if (this.authorized) {
            await this.$store.dispatch('postCart', this.cleanItems(val))
          } else {
            localStorage.setItem('products', JSON.stringify(val))
          }
          this.$store.dispatch('updateCart')
        }

        await saveCart(products)

        if (showPopup) this.popupAddCart()

        if (enableTracking) {
          this.addCartCode({
            productID: item.id,
            unit: '1',
            price: item.pricing
          })
        }
      }
    },

    // 刪除購物車
    removeShoppingList () {
      if (this.authorized) {
        this.$store.dispatch('postCart', [])
      } else {
        localStorage.removeItem('products')
      }
    },

    async removeShoppingItem (id, item, index) {
      let products = JSON.parse(JSON.stringify(this.cartList)) || []

      // 確保 index 有效且 ID 符合
      if (products[index] && products[index].id === id) {
        products.splice(index, 1) // 刪除該筆

        // 儲存更新後的購物車
        if (this.authorized) {
          await this.$store.dispatch('postCart', products)
        } else {
          if (products.length) {
            localStorage.setItem('products', JSON.stringify(products))
          } else {
            localStorage.removeItem('products')
          }
          this.$store.dispatch('updateCart')
        }
      } else {
        console.warn('index 或 id 不一致，未執行刪除')
      }
    },

    cleanItems (arr) {
      const keysToKeep = [
        'name', 'pricing', 'type', 'fixed_price', 'cover', 'category_name',
        'free_gifts', 'free_items', 'gift_num', 'id', 'in_stock',
        'is_digital', 'is_favorite', 'quantity', 'selected_gifts', 'in_stock', 'is_tax', 'isRegisteredMail', 'package', 'begin_at', 'end_at', 'link', 'link_id'
      ]

      return arr.map(obj =>
        Object.fromEntries(
          Object.entries(obj).filter(([key]) => keysToKeep.includes(key))
        )
      )
    }
  }
}

export default Cart
